import { Form, Row, Col, Input } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import InputFields from "../../../common/components/InputFields";
import getConfigs from "../../../GetConfigs";

const CivilPlantiffDetail = ({ ...props }) => {
  const { form } = props;

  const configurations = getConfigs([
    "cvAttorneyPhone",
    "cvPlaintiffDefendantAddr",
  ]);
  return (
    <BannerCard title="Plantiff Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="PrimaryPlaintiffName" formItemLabel="Name" condition="Y" />
          <InputFields.InputTextField
            responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }}
            formItemName="PrimaryPlaintiffPhysicalAddress1"
            formItemLabel="Address"
            condition={configurations.cvPlaintiffDefendantAddr}
          />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryPlaintiffPhysicalCity" formItemLabel="City" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryPlaintiffPhysicalState" formItemLabel="State" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryPlaintiffPhysicalZipCode" formItemLabel="Zip" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PlaintiffAttorneyName" formItemLabel="Attorney Name" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PlaintiffAttorneyPhone" formItemLabel="Attorney Phone" condition={configurations.cvAttorneyPhone} />
          <Col xl={8} lg={8} md={8} sm={8} xs={24}>
            <Form.Item name="PlaintiffCount" label="Plaintiff Count">
              <CleanButton icon="eye" type="link" block onClick={() => props.setActiveKey("5")}>
                {props.civilMaster?.summary?.MAIN[0]?.PlaintiffCount}
              </CleanButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CivilPlantiffDetail;
